import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Menu } from "antd";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  TeamOutlined,
  DatabaseOutlined,
} from "@ant-design/icons";
import logo from "../../assets/images/BIS logo.svg";
import "../../assets/style/menu.css";
import {
  setCollapse,
  setSelectedPath,
  setOpenMiniMenu,
} from "../../slice/mainSlice";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  MdAccountBalanceWallet,
  MdDashboard,
  MdOutlinePayment,
  MdOutlinePayments,
} from "react-icons/md";
import { BiSolidReport } from "react-icons/bi";
import { RiExchangeDollarLine } from "react-icons/ri";

export const Menubar = () => {
  const { t } = useTranslation();
  const { collapse, selectedPath, openMiniMenu } = useSelector(
    (state) => state.main,
  );
  const role = useSelector((state) => state.main.role);
  const dispatch = useDispatch();
  const [menuHeight, setMenuHeight] = useState("auto");

  const navigate = useNavigate();

  useEffect(() => {
    const menu = document.getElementById("menu");
    if (menu) {
      setMenuHeight(`${menu.scrollHeight}px`);
    }
  }, [collapse]);

  const toggleCollapsed = () => {
    dispatch(setCollapse(!collapse));
  };
  const onSelectMenuItem = (item) => {
    dispatch(setSelectedPath(item.key));
    navigate(`/${item.key}`);
  };

  const getMenuItems = () => {
    let items = [
      {
        key: "dashboard",
        icon: <MdDashboard style={{ fontSize: "25px", color: "white" }} />,
        label: t("dashboard"),
        className: "md:block hidden",
      },
      // {
      //   key: "incoming payment",
      //   icon: (
      //     <MdOutlinePayments style={{ color: "white", fontSize: "25px" }} />
      //   ),
      //   label: t("incoming payment"),
      //   children: [
      //     {
      //       key: "accepting-payment-from-customer",
      //       label: t("mijozdan pul qabul qilish"),
      //     },
      //     {
      //       key: "accepting-payment-from-delivery",
      //       label: t("yetkazib beruvchidan pul qabul qilish"),
      //     },
      //     {
      //       key: "accepting-payment-from-account",
      //       label: t("hisobdan pul qabul qilish"),
      //     },
      //   ],
      // },
      // {
      //   key: "outgoing payment",
      //   icon: <MdOutlinePayment style={{ color: "white", fontSize: "25px" }} />,
      //   label: t("Outgoing payment"),
      //   children: [
      //     {
      //       key: "outgoing-payment-supplier",
      //       label: t("Yetkazib beruvchiga to'lov"),
      //     },
      //     {
      //       key: "create-payment",
      //       label: t("To'lov yaratish"),
      //     },
      //   ],
      // },
      // {
      //   key: "Akt sverki",
      //   icon: (
      //     <MdAccountBalanceWallet
      //       style={{ color: "white", fontSize: "25px" }}
      //     />
      //   ),
      //   label: t("Akt sverki"),
      //   children: [
      //     {
      //       key: "act-sverki",
      //       label: t("Act sverki"),
      //     },
      //   ],
      // },
      {
        key: "sub1",
        icon: (
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/3000/svg"
          >
            <path
              d="M18.75 8.75H11.25C9.86929 8.75 8.75 9.86929 8.75 11.25V18.75C8.75 20.1307 9.86929 21.25 11.25 21.25H18.75C20.1307 21.25 21.25 20.1307 21.25 18.75V11.25C21.25 9.86929 20.1307 8.75 18.75 8.75Z"
              stroke="white"
              stroke-width="1.5"
            />
            <path
              d="M16.25 12.5H13.75"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M27.5 15C27.5 21.9035 21.9035 27.5 15 27.5C10.9104 27.5 7.2796 25.5361 4.99909 22.5M2.5 15C2.5 8.09644 8.09644 2.5 15 2.5C19.0895 2.5 22.7204 4.46389 25.0009 7.5"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
            />
            <path
              d="M5 22.5L3.75 26.25"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
            />
            <path
              d="M25 7.5L26.25 3.75"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </svg>
        ),
        label: t("salesForOrder"),
        children: [
          {
            key: "my-sales",
            label: t("Sales"),
          },
          {
            key: "shipments",
            label: t("shipments"),
          },
          {
            key: "returned-items",
            label: t("returned-items"),
          },
          {
            key: "closing-sale",
            label: t("finishedSales"),
          },
        ],
      },
      {
        key: "sub2",
        icon: <TeamOutlined style={{ fontSize: "25px", color: "white" }} />,
        label: t("clients"),
        children: [
          {
            key: "clients",
            label: t("clientsG"),
          },
          {
            key: "debtors",
            label: t("debtors"),
          },
        ],
      },

      {
        key: "reports",
        icon: <DatabaseOutlined style={{ fontSize: "25px", color: "white" }} />,
        label: t("reports"),
      },
      {
        key: "sub3",
        icon: <BiSolidReport style={{ fontSize: "25px", color: "white" }} />,
        label: t("dashboardReports"),
        children: [
          {
            key: "tracking",
            label: t("tracking"),
          },
          {
            key: "shippedReports",
            label: t("shippedReports"),
          },
        ],
      },
    ];

    return items;
  };

  console.log("log", role);
  const items =
    role === "Cashier"
      ? [
          {
            key: "incoming payment",
            icon: (
              <MdOutlinePayments style={{ color: "white", fontSize: "25px" }} />
            ),
            label: t("incoming payment"),
            children: [
              {
                key: "accepting-payment-from-customer",
                label: t("mijozdan pul qabul qilish"),
              },
              {
                key: "accepting-payment-from-delivery",
                label: t("yetkazib beruvchidan pul qabul qilish"),
              },
              {
                key: "accepting-payment-from-account",
                label: t("hisobdan pul qabul qilish"),
              },
            ],
          },
          {
            key: "outgoing payment",
            icon: (
              <MdOutlinePayment style={{ color: "white", fontSize: "25px" }} />
            ),
            label: t("Outgoing payment"),
            children: [
              {
                key: "outgoing-payment-supplier",
                label: t("Yetkazib beruvchiga to'lov"),
              },
              {
                key: "create-payment",
                label: t("To'lov yaratish"),
              },
            ],
          },
          {
            key: "Akt sverki",
            icon: (
              <MdAccountBalanceWallet
                style={{ color: "white", fontSize: "25px" }}
              />
            ),
            label: t("Akt sverki"),
            children: [
              {
                key: "act-sverki",
                label: t("Act sverki"),
              },
            ],
          },
          {
            key: "conversion",
            icon: (
              <RiExchangeDollarLine
                style={{ color: "white", fontSize: "25px" }}
              />
            ),
            label: t("Conversion"),
          },
        ]
      : getMenuItems();

  return (
    <div className="flex">
      <div
        className={`${
          collapse ? "w-[80px]" : "w-[290px]"
        } h-${menuHeight} bg-[#0A4D68]`}
      >
        <div className="flex gap-12 pt-7">
          {collapse ? "" : <img src={logo} alt="" className="ml-7" />}

          <button
            onClick={toggleCollapsed}
            className="bg-[#0A4D68] text-2xl text-white"
          >
            {collapse ? (
              <MenuUnfoldOutlined className="ml-8" />
            ) : (
              <MenuFoldOutlined />
            )}
          </button>
        </div>
        <div className="mt-20">
          <Menu
            defaultOpenKeys={openMiniMenu}
            selectedKeys={[selectedPath]}
            mode="inline"
            inlineCollapsed={collapse}
            items={items}
            className="m-auto bg-transparent"
            theme="light"
            onSelect={onSelectMenuItem}
            onOpenChange={(v) => {
              dispatch(setOpenMiniMenu(v));
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Menubar;
